import DashboardHead from "../../../../../components/categories/siakad/laporan_adab/beranda/HomeHead";
export default function Home() {
    return (<DashboardHead />);
}